import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";
import { WrittenAssigmentsRecordActionTypes } from "src/app/constants/StoreConstants";

export const GetWrittenAssignmentRecords = createAction(
  WrittenAssigmentsRecordActionTypes.GetWrittenAssignmentRecords,
  props<{courseId: number}>()
);

export const ViewWrittenAssignmentRecords = createAction(
  WrittenAssigmentsRecordActionTypes.ViewWrittenAssignmentRecords,
  props<{courseId: number, learnerId: number}>()
);

export const GetWrittenAssignmentRecordsSuccess = createAction(
  WrittenAssigmentsRecordActionTypes.GetWrittenAssignmentRecordsSuccess,
  props<{result: LearnerLearningRecord[]}>()
);

export const GetWrittenAssignmentRecordsError = createAction(
  WrittenAssigmentsRecordActionTypes.GetWrittenAssignmentRecordsError,
  props<{error: HttpErrorResponse}>()
);